import * as React from 'react';
import { PopoverCommonProps } from '../common';

export interface SwatchesProps {
  dataHook?: string;
  colors?: (object | string)[];
  selected?: string;
  onClick?: string | object;
  size?: 'small' | 'medium';
  showClear?: boolean;
  showClearMessage?: React.ReactNode;
  onAdd?: Function;
  onChange?: Function;
  onCancel?: Function;
  showAddButton?: boolean;
  addButtonMessage?: string;
  addButtonIconSize?: 'small' | 'medium';
  columns?: number;
  gap?: number;
  popoverProps?: PopoverCommonProps;
}

export default class Swatches extends React.PureComponent<SwatchesProps> {}
